import { render, staticRenderFns } from "./CountryRankChart.vue?vue&type=template&id=4465f49f&"
import script from "./CountryRankChart.vue?vue&type=script&lang=js&"
export * from "./CountryRankChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports